export const ACTION_DEPARTMENT_LIST = 'ACTION_DEPARTMENT_LIST';

export const actDepartmentList = department => {
  return {
    type: ACTION_DEPARTMENT_LIST,
    department
  }
};